export const defaultMatchTypes = ["League", "Playoff", "Event"];
